import { LearningProgressReportCompanyPage } from "@/features/learning-progress/pages/LearningProgressReportCompany";

export default LearningProgressReportCompanyPage;
